/******/ (() => { // webpackBootstrap
/******/ 	"use strict";
/******/ 	var __webpack_modules__ = ({

/***/ "./src/js/formatMoney.js":
/*!*******************************!*\
  !*** ./src/js/formatMoney.js ***!
  \*******************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   formatMoney: () => (/* binding */ formatMoney)
/* harmony export */ });
// ---------------------------------------------------------------------------
// Money format handler
// ---------------------------------------------------------------------------

function formatMoney(cents, format) {
  if (typeof cents == 'string') {
    cents = cents.replace('.', '');
  }
  var value = '';
  var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
  var formatString = format || "${{amount}}";
  function defaultOption(opt, def) {
    return typeof opt == 'undefined' ? def : opt;
  }
  function formatWithDelimiters(number, precision, thousands, decimal) {
    precision = defaultOption(precision, 2);
    thousands = defaultOption(thousands, ',');
    decimal = defaultOption(decimal, '.');
    if (isNaN(number) || number == null) {
      return 0;
    }
    number = (number / 100.0).toFixed(precision);
    var parts = number.split('.'),
      dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands),
      cents = parts[1] ? decimal + parts[1] : '';
    return dollars + cents;
  }
  switch (formatString.match(placeholderRegex)[1]) {
    case 'amount':
      value = formatWithDelimiters(cents, 2);
      break;
    case 'amount_no_decimals':
      value = formatWithDelimiters(cents, 0);
      break;
    case 'amount_with_comma_separator':
      value = formatWithDelimiters(cents, 2, '.', ',');
      break;
    case 'amount_no_decimals_with_comma_separator':
      value = formatWithDelimiters(cents, 0, '.', ',');
      break;
    case "amount_with_apostrophe_separator":
      value = formatWithDelimiters(cents, 2, "'", ".");
      break;
  }
  return formatString.replace(placeholderRegex, value);
}
;

/***/ }),

/***/ "./src/js/initProductVariants.js":
/*!***************************************!*\
  !*** ./src/js/initProductVariants.js ***!
  \***************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   initProductVariants: () => (/* binding */ initProductVariants)
/* harmony export */ });
/* harmony import */ var _formatMoney__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./formatMoney */ "./src/js/formatMoney.js");
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == _typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw new Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator["return"] && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError(_typeof(e) + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw new Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, "catch": function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw new Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }
function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }


/**
 * Variant picker logic shared by the PDP and quick-add modal.
 * @param {ParentNode} scope - Root element to query within
 * @param {object} options
 */
function initProductVariants(scope) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var _options$updateUrl = options.updateUrl,
    updateUrl = _options$updateUrl === void 0 ? true : _options$updateUrl,
    _options$useSectionPr = options.useSectionPrice,
    useSectionPrice = _options$useSectionPr === void 0 ? true : _options$useSectionPr,
    _options$onVariantCha = options.onVariantChange,
    onVariantChange = _options$onVariantCha === void 0 ? null : _options$onVariantCha;
  var productVariants = scope.querySelector('[data-product-variants]') || scope.querySelector('#product-variants');
  if (!productVariants) return null;
  var radioBtns = productVariants.querySelectorAll('input[type="radio"]');
  var variantFieldsets = productVariants.querySelectorAll('fieldset');
  var form = scope.querySelector('form[action*="/cart/add"]');
  var masterVariantField = form === null || form === void 0 ? void 0 : form.querySelector('input[name="id"]');
  var cartBtn = form === null || form === void 0 ? void 0 : form.querySelector('button[type="submit"]');
  var preOrderInfo = scope.querySelector('.js-pre-order-info');
  var getVariantData = function getVariantData() {
    return JSON.parse(productVariants.querySelector('[type="application/json"]').textContent);
  };
  var updateLclyUPC = function updateLclyUPC(variantId) {
    var variantRadio = scope.querySelector("input[data-variant-id=\"".concat(variantId, "\"]"));
    if (variantRadio) {
      var variantBarcode = variantRadio.getAttribute('data-variant-barcode');
      if (variantBarcode && typeof lcly_reload_0 === 'function') {
        lcly_reload_0({
          upc: variantBarcode
        });
      }
    }
  };
  var updatePriceFromVariant = function updatePriceFromVariant(variant) {
    var priceContainer = scope.querySelector('.product-price-container');
    if (!priceContainer || !variant) return;
    var priceEl = priceContainer.querySelector('.js-product-price');
    var compareEl = priceContainer.querySelector('.js-product-compare-at-price');
    if (priceEl) {
      priceEl.textContent = (0,_formatMoney__WEBPACK_IMPORTED_MODULE_0__.formatMoney)(variant.price, window.theme.moneyFormat);
      if (variant.compare_at_price && variant.compare_at_price > variant.price) {
        priceEl.classList.add('text-secondary');
        priceEl.classList.remove('text-black');
      } else {
        priceEl.classList.remove('text-secondary');
        priceEl.classList.add('text-black');
      }
    }
    if (compareEl) {
      if (variant.compare_at_price && variant.compare_at_price > variant.price) {
        compareEl.textContent = (0,_formatMoney__WEBPACK_IMPORTED_MODULE_0__.formatMoney)(variant.compare_at_price, window.theme.moneyFormat);
        compareEl.classList.remove('hidden');
      } else {
        compareEl.classList.add('hidden');
      }
    }
  };
  var variantPrice = /*#__PURE__*/function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
      var _priceEl$closest;
      var priceEl, sectionId, sanitisedSectionId, data, renderedProductSection, productPrice, renderedProductPrice;
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            priceEl = scope.querySelector('.js-product-price');
            sectionId = priceEl === null || priceEl === void 0 || (_priceEl$closest = priceEl.closest('.shopify-section')) === null || _priceEl$closest === void 0 ? void 0 : _priceEl$closest.id;
            sanitisedSectionId = sectionId === null || sectionId === void 0 ? void 0 : sectionId.split('__').slice(-1).pop();
            if (sanitisedSectionId) {
              _context.next = 5;
              break;
            }
            return _context.abrupt("return");
          case 5:
            _context.next = 7;
            return fetch(window.location.href + "&sections=".concat(sanitisedSectionId)).then(function (res) {
              return res.json();
            });
          case 7:
            data = _context.sent;
            renderedProductSection = new DOMParser().parseFromString(data[Object.keys(data)[0]], 'text/html');
            productPrice = scope.querySelector('.product-price-container');
            renderedProductPrice = renderedProductSection.querySelector('.product-price-container');
            if (productPrice && renderedProductPrice) {
              productPrice.innerHTML = renderedProductPrice.innerHTML;
            }
          case 12:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
    return function variantPrice() {
      return _ref.apply(this, arguments);
    };
  }();
  var addToBagBtn = function addToBagBtn(available, variantId) {
    if (!cartBtn) return;
    var preOrder = false;
    var preOrderCheck = scope.querySelector("input[data-variant-id=\"".concat(variantId, "\"]"));
    if (preOrderCheck !== null && preOrderCheck !== void 0 && preOrderCheck.classList.contains('js-pre-order')) {
      preOrder = true;
    }
    var preOrderDate = scope.querySelector("[data-pre-order-date=\"".concat(variantId, "\"]"));
    var preOrderDateText = preOrderDate === null || preOrderDate === void 0 ? void 0 : preOrderDate.innerHTML;
    var locallyWidget = scope.querySelector('.js-locally-widget-soldout');
    if (locallyWidget) {
      if (!available && !preOrder) {
        locallyWidget.classList.remove('locally-widget-hidden');
        locallyWidget.classList.add('locally-widget-visible');
      } else {
        locallyWidget.classList.remove('locally-widget-visible');
        locallyWidget.classList.add('locally-widget-hidden');
      }
    }
    if (preOrder) {
      cartBtn.classList.remove('btn-disabled');
      cartBtn.classList.add('btn-secondary', 'pre-order');
      cartBtn.disabled = false;
      if (preOrderInfo) {
        preOrderInfo.innerHTML = window.product.preOrderDateIntro + ' ' + preOrderDateText;
        preOrderInfo.classList.remove('hidden');
      }
    } else if (available) {
      cartBtn.classList.remove('btn-disabled', 'pre-order');
      cartBtn.classList.add('btn-secondary');
      cartBtn.disabled = false;
      preOrderInfo === null || preOrderInfo === void 0 || preOrderInfo.classList.add('hidden');
    } else {
      cartBtn.classList.add('btn-disabled');
      cartBtn.classList.remove('btn-secondary', 'pre-order');
      cartBtn.disabled = true;
      preOrderInfo === null || preOrderInfo === void 0 || preOrderInfo.classList.add('hidden');
    }
    var currentSelectedVariant = productVariants.querySelector('.variant-radio input[type="radio"]:checked');
    if (!currentSelectedVariant) return;
    var currentSelectedValue = currentSelectedVariant.value;
    scope.querySelectorAll('.js-swatch-link').forEach(function (swatchLink) {
      var swatchProductVariants = swatchLink.getAttribute('data-swatch-product-variants');
      var swatchVariantValues = swatchProductVariants.split(' ').map(function (value) {
        return value.split('-')[0];
      });
      var swatchVariantId = swatchProductVariants.split(' ').map(function (value) {
        return value.split('-')[1];
      });
      if (swatchVariantValues.includes(currentSelectedValue)) {
        var matchingSwatchVariantId = swatchVariantId[swatchVariantValues.indexOf(currentSelectedValue)];
        swatchLink.setAttribute('href', swatchLink.getAttribute('href').replace(/\?variant=.*$/, '') + '?variant=' + matchingSwatchVariantId);
      }
    });
  };
  var finalVariant = function finalVariant(variant) {
    if (!variant || !masterVariantField) return;
    masterVariantField.value = variant.id;
    if (useSectionPrice) {
      variantPrice(variant.id);
    } else {
      updatePriceFromVariant(variant);
    }
    addToBagBtn(variant.available, variant.id);
    updateLclyUPC(variant.id);
    if (typeof onVariantChange === 'function') {
      onVariantChange(variant);
    }
    if (updateUrl) {
      var currentURLWithoutParams = window.location.href.split('?')[0];
      history.pushState(null, null, currentURLWithoutParams + '?variant=' + variant.id);
    }
  };
  var remainingOptions = function remainingOptions(checkedBtns) {
    if (variantFieldsets.length === 1) {
      productVariants.querySelectorAll('.js-unavailable-variant').forEach(function (label) {
        label.classList.remove('js-unavailable-variant');
      });
    }
    checkedBtns.forEach(function (radio, index) {
      if (index === 0) {
        var _remainingVariants;
        var remainingVariants;
        if (variantFieldsets.length === 1) {
          remainingVariants = getVariantData().filter(function (variant) {
            return variant.available === false;
          });
        } else if (variantFieldsets.length === 2) {
          remainingVariants = getVariantData().filter(function (variant) {
            return variant.option1 === checkedBtns[0].value;
          }).sort(function (variant) {
            return variant.available ? 1 : -1;
          });
        } else if (variantFieldsets.length > 2) {
          remainingVariants = getVariantData().filter(function (variant) {
            return variant.option1 === checkedBtns[0].value && variant.option2 === checkedBtns[1].value;
          }).sort(function (variant) {
            return variant.available ? 1 : -1;
          });
        }
        (_remainingVariants = remainingVariants) === null || _remainingVariants === void 0 || _remainingVariants.forEach(function (variant) {
          if (variantFieldsets.length === 1) {
            var _productVariants$quer;
            (_productVariants$quer = productVariants.querySelector(".js-variant-label[data-label-value=\"".concat(variant.option1, "\"]"))) === null || _productVariants$quer === void 0 || _productVariants$quer.classList.add('js-unavailable-variant');
          }
          if (variantFieldsets.length >= 2) {
            var label = productVariants.querySelector(".js-variant-label[data-label-value=\"".concat(variant.option2, "\"]"));
            if (variant.available) {
              label === null || label === void 0 || label.classList.remove('js-unavailable-variant');
            } else {
              label === null || label === void 0 || label.classList.add('js-unavailable-variant');
            }
          }
          if (variantFieldsets.length > 2) {
            var _label = productVariants.querySelector(".js-variant-label[data-label-value=\"".concat(variant.option3, "\"]"));
            if (variant.available) {
              _label === null || _label === void 0 || _label.classList.remove('js-unavailable-variant');
            } else {
              _label === null || _label === void 0 || _label.classList.add('js-unavailable-variant');
            }
          }
        });
      }
      if (index === 1) {
        var _remainingVariants3;
        var _remainingVariants2;
        if (variantFieldsets.length === 2) {
          _remainingVariants2 = getVariantData().filter(function (variant) {
            return variant.option2 === checkedBtns[1].value;
          }).sort(function (variant) {
            return variant.available ? 1 : -1;
          });
        } else if (variantFieldsets.length > 2) {
          _remainingVariants2 = getVariantData().filter(function (variant) {
            return variant.option2 === checkedBtns[1].value && variant.option3 === checkedBtns[2].value;
          }).sort(function (variant) {
            return variant.available ? 1 : -1;
          });
        }
        (_remainingVariants3 = _remainingVariants2) === null || _remainingVariants3 === void 0 || _remainingVariants3.forEach(function (variant) {
          if (variantFieldsets.length >= 2) {
            var label = productVariants.querySelector(".js-variant-label[data-label-value=\"".concat(variant.option1, "\"]"));
            if (variant.available) {
              label === null || label === void 0 || label.classList.remove('js-unavailable-variant');
            } else {
              label === null || label === void 0 || label.classList.add('js-unavailable-variant');
            }
          }
          if (variantFieldsets.length > 2) {
            var _label2 = productVariants.querySelector(".js-variant-label[data-label-value=\"".concat(variant.option3, "\"]"));
            if (variant.available) {
              _label2 === null || _label2 === void 0 || _label2.classList.remove('js-unavailable-variant');
            } else {
              _label2 === null || _label2 === void 0 || _label2.classList.add('js-unavailable-variant');
            }
          }
        });
      }
      if (index === 2) {
        var _remainingVariants4 = getVariantData().filter(function (variant) {
          return variant.option3 === checkedBtns[2].value && variant.option1 === checkedBtns[0].value;
        }).sort(function (variant) {
          return variant.available ? 1 : -1;
        });
        _remainingVariants4.forEach(function (variant) {
          var label1 = productVariants.querySelector(".js-variant-label[data-label-value=\"".concat(variant.option1, "\"]"));
          var label2 = productVariants.querySelector(".js-variant-label[data-label-value=\"".concat(variant.option2, "\"]"));
          if (variant.available) {
            label1 === null || label1 === void 0 || label1.classList.remove('js-unavailable-variant');
            label2 === null || label2 === void 0 || label2.classList.remove('js-unavailable-variant');
          } else {
            label1 === null || label1 === void 0 || label1.classList.add('js-unavailable-variant');
            label2 === null || label2 === void 0 || label2.classList.add('js-unavailable-variant');
          }
        });
      }
    });
  };
  radioBtns.forEach(function (radio) {
    return radio.addEventListener('change', function () {
      var radioBtnsChecked = productVariants.querySelectorAll('input[type="radio"]:checked');
      var optionCombine = radioBtnsChecked[0].value;
      if (variantFieldsets.length >= 2) {
        optionCombine += ' / ' + radioBtnsChecked[1].value;
      }
      if (variantFieldsets.length > 2) {
        optionCombine += ' / ' + radioBtnsChecked[2].value;
      }
      var combineVariant = getVariantData().filter(function (variant) {
        return variant.title === optionCombine;
      });
      finalVariant(combineVariant[0]);
      remainingOptions(radioBtnsChecked);
    });
  });
  var currentRadioBtnsChecked = productVariants.querySelectorAll('input[type="radio"]:checked');
  remainingOptions(currentRadioBtnsChecked);
  return {
    getVariantData: getVariantData,
    finalVariant: finalVariant
  };
}

/***/ })

/******/ 	});
/************************************************************************/
/******/ 	// The module cache
/******/ 	var __webpack_module_cache__ = {};
/******/ 	
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/ 		// Check if module is in cache
/******/ 		var cachedModule = __webpack_module_cache__[moduleId];
/******/ 		if (cachedModule !== undefined) {
/******/ 			return cachedModule.exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = __webpack_module_cache__[moduleId] = {
/******/ 			// no module.id needed
/******/ 			// no module.loaded needed
/******/ 			exports: {}
/******/ 		};
/******/ 	
/******/ 		// Execute the module function
/******/ 		__webpack_modules__[moduleId](module, module.exports, __webpack_require__);
/******/ 	
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/ 	
/************************************************************************/
/******/ 	/* webpack/runtime/define property getters */
/******/ 	(() => {
/******/ 		// define getter functions for harmony exports
/******/ 		__webpack_require__.d = (exports, definition) => {
/******/ 			for(var key in definition) {
/******/ 				if(__webpack_require__.o(definition, key) && !__webpack_require__.o(exports, key)) {
/******/ 					Object.defineProperty(exports, key, { enumerable: true, get: definition[key] });
/******/ 				}
/******/ 			}
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/hasOwnProperty shorthand */
/******/ 	(() => {
/******/ 		__webpack_require__.o = (obj, prop) => (Object.prototype.hasOwnProperty.call(obj, prop))
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/make namespace object */
/******/ 	(() => {
/******/ 		// define __esModule on exports
/******/ 		__webpack_require__.r = (exports) => {
/******/ 			if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 				Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 			}
/******/ 			Object.defineProperty(exports, '__esModule', { value: true });
/******/ 		};
/******/ 	})();
/******/ 	
/************************************************************************/
var __webpack_exports__ = {};
// This entry needs to be wrapped in an IIFE because it needs to be isolated against other modules in the chunk.
(() => {
/*!*****************************!*\
  !*** ./src/js/quick-add.js ***!
  \*****************************/
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   closeQuickAdd: () => (/* binding */ closeQuickAdd),
/* harmony export */   openQuickAdd: () => (/* binding */ openQuickAdd)
/* harmony export */ });
/* harmony import */ var _initProductVariants__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./initProductVariants */ "./src/js/initProductVariants.js");

var quickAddFlkty = null;
var quickAddOpen = false;
var activeTrigger = null;
function setActiveTrigger(trigger) {
  document.querySelectorAll('.cart-rec-card--quick-add-active').forEach(function (el) {
    el.classList.remove('cart-rec-card--quick-add-active');
  });
  activeTrigger = trigger || null;
  if (activeTrigger) {
    var _activeTrigger$closes;
    (_activeTrigger$closes = activeTrigger.closest('.cart-rec-card')) === null || _activeTrigger$closes === void 0 || _activeTrigger$closes.classList.add('cart-rec-card--quick-add-active');
  }
}
var modal = function modal() {
  return document.getElementById('quick-add-modal');
};
var content = function content() {
  return document.querySelector('[data-quick-add-content]');
};
function destroyGallery() {
  if (quickAddFlkty) {
    try {
      quickAddFlkty.destroy();
    } catch (e) {}
    quickAddFlkty = null;
  }
}
function updateSaleBadge(variant, badgeEl) {
  if (!badgeEl || !variant) return;
  if (variant.compare_at_price && variant.compare_at_price > variant.price) {
    var percent = Math.round((variant.compare_at_price - variant.price) / variant.compare_at_price * 100);
    badgeEl.textContent = "-".concat(percent, "%");
    badgeEl.classList.remove('hidden');
  } else {
    badgeEl.classList.add('hidden');
  }
}
function selectGalleryImage(variant) {
  var _content;
  if (!quickAddFlkty || !(variant !== null && variant !== void 0 && variant.featured_image)) return;
  var gallery = (_content = content()) === null || _content === void 0 ? void 0 : _content.querySelector('[data-quick-add-gallery]');
  if (!gallery) return;
  var cells = quickAddFlkty.getCellElements();
  var targetSrc = variant.featured_image.src;
  var index = Array.from(cells).findIndex(function (cell) {
    var img = cell.querySelector('img');
    return img && (img.dataset.src === targetSrc || img.src === targetSrc || img.dataset.imageId == variant.featured_image.id);
  });
  if (index >= 0) {
    quickAddFlkty.select(index);
  }
}
function initGallery() {
  var _content2;
  destroyGallery();
  var gallery = (_content2 = content()) === null || _content2 === void 0 ? void 0 : _content2.querySelector('[data-quick-add-gallery]');
  if (!gallery || !window.Flickity) return;
  var wrap = gallery.closest('.quick-add-product__gallery');
  var prev = wrap === null || wrap === void 0 ? void 0 : wrap.querySelector('[data-quick-add-prev]');
  var next = wrap === null || wrap === void 0 ? void 0 : wrap.querySelector('[data-quick-add-next]');
  var hasMultiple = gallery.children.length > 1;
  if (prev) prev.classList.toggle('hidden', !hasMultiple);
  if (next) next.classList.toggle('hidden', !hasMultiple);
  if (!hasMultiple) return;
  quickAddFlkty = new window.Flickity(gallery, {
    cellAlign: 'center',
    contain: true,
    pageDots: false,
    prevNextButtons: false,
    wrapAround: true,
    adaptiveHeight: false
  });
  if (prev) prev.onclick = function () {
    return quickAddFlkty.previous();
  };
  if (next) next.onclick = function () {
    return quickAddFlkty.next();
  };
}
function initDescriptionToggle(root) {
  var desc = root.querySelector('[data-quick-add-description]');
  var btn = root.querySelector('[data-quick-add-read-more]');
  if (!desc || !btn) return;
  setDescriptionExpanded(false);
  requestAnimationFrame(function () {
    if (desc.scrollHeight > desc.clientHeight + 1) {
      btn.classList.remove('hidden');
    }
  });
  btn.addEventListener('click', function () {
    var collapsed = desc.classList.toggle('is-collapsed');
    setDescriptionExpanded(!collapsed);
    btn.textContent = collapsed ? btn.dataset.labelMore : btn.dataset.labelLess;
    btn.setAttribute('aria-expanded', String(!collapsed));
  });
}
function setDescriptionExpanded(expanded) {
  var _modal;
  (_modal = modal()) === null || _modal === void 0 || _modal.classList.toggle('quick-add-modal--desc-expanded', expanded);
}
function initQuickAddProduct(root) {
  var badgeEl = root.querySelector('[data-quick-add-badge]');
  var variantApi = (0,_initProductVariants__WEBPACK_IMPORTED_MODULE_0__.initProductVariants)(root, {
    updateUrl: false,
    useSectionPrice: false,
    onVariantChange: function onVariantChange(variant) {
      updateSaleBadge(variant, badgeEl);
      selectGalleryImage(variant);
    }
  });
  if (variantApi) {
    var checked = root.querySelectorAll('[data-product-variants] input[type="radio"]:checked');
    if (checked.length) {
      var optionCombine = checked[0].value;
      var fieldsets = root.querySelectorAll('[data-product-variants] fieldset');
      if (fieldsets.length >= 2) optionCombine += ' / ' + checked[1].value;
      if (fieldsets.length > 2) optionCombine += ' / ' + checked[2].value;
      var variant = variantApi.getVariantData().find(function (v) {
        return v.title === optionCombine;
      });
      if (variant) {
        updateSaleBadge(variant, badgeEl);
        selectGalleryImage(variant);
      }
    }
  }
  initGallery();
  initDescriptionToggle(root);
  if (window.lazySizes) {
    window.lazySizes.loader.checkElems();
  }
}
function setLoading(isLoading) {
  var el = content();
  if (!el) return;
  el.classList.toggle('quick-add-modal__content--loading', isLoading);
}
function setCartQuickAddState(isOpen) {
  var miniCart = document.getElementById('mini-cart');
  if (!miniCart) return;
  miniCart.classList.toggle('mini-cart--quick-add-open', isOpen);
}
function updateModalCartLayout() {
  var _document$getElementB;
  var m = modal();
  if (!m) return;
  var cartIsOpen = (_document$getElementB = document.getElementById('mini-cart')) === null || _document$getElementB === void 0 ? void 0 : _document$getElementB.classList.contains('mini-cart--active');
  m.classList.toggle('quick-add-modal--with-cart', Boolean(cartIsOpen));
}
function closeQuickAdd() {
  var m = modal();
  if (!m || !m.classList.contains('quick-add-modal--active')) return;
  quickAddOpen = false;
  setActiveTrigger(null);
  m.classList.remove('quick-add-modal--active');
  m.classList.remove('quick-add-modal--desc-expanded');
  m.setAttribute('aria-hidden', 'true');
  document.body.classList.remove('overflow-hidden');
  destroyGallery();
  setTimeout(function () {
    if (quickAddOpen) return;
    setCartQuickAddState(false);
    m.classList.remove('quick-add-modal--with-cart');
    if (content()) {
      content().innerHTML = '';
    }
  }, 300);
}
function openQuickAdd(handle) {
  var _document$getElementB2;
  var trigger = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
  var m = modal();
  var target = content();
  if (!m || !target || !handle) return;
  if (trigger) {
    setActiveTrigger(trigger);
  } else {
    var matchingTrigger = document.querySelector("[data-quick-add-trigger][data-product-handle=\"".concat(handle, "\"]"));
    setActiveTrigger(matchingTrigger);
  }
  quickAddOpen = true;
  updateModalCartLayout();
  setCartQuickAddState((_document$getElementB2 = document.getElementById('mini-cart')) === null || _document$getElementB2 === void 0 ? void 0 : _document$getElementB2.classList.contains('mini-cart--active'));
  m.classList.add('quick-add-modal--active');
  m.setAttribute('aria-hidden', 'false');
  document.body.classList.add('overflow-hidden');
  setLoading(true);
  fetch("".concat(window.Shopify.routes.root, "products/").concat(handle, "?section_id=quick-add")).then(function (response) {
    return response.ok ? response.text() : Promise.reject(response.status);
  }).then(function (html) {
    if (!quickAddOpen) return;
    var doc = new DOMParser().parseFromString(html, 'text/html');
    var productRoot = doc.querySelector('[data-quick-add-product]');
    if (!productRoot) {
      setLoading(false);
      return;
    }
    target.innerHTML = productRoot.outerHTML;
    setLoading(false);
    initQuickAddProduct(target.querySelector('[data-quick-add-product]'));
  })["catch"](function (error) {
    console.error('Quick add failed:', error);
    setLoading(false);
    closeQuickAdd();
  });
}
function bindQuickAddTriggers() {
  document.addEventListener('click', function (event) {
    var trigger = event.target.closest('[data-quick-add-trigger]');
    if (!trigger) return;
    event.preventDefault();
    event.stopPropagation();
    var handle = trigger.getAttribute('data-product-handle');
    if (handle) openQuickAdd(handle, trigger);
  });
}
function bindQuickAddModal() {
  var _m$querySelector;
  var m = modal();
  if (!m) return;
  m.addEventListener('click', function (event) {
    if (event.target.closest('[data-quick-add-close]')) {
      closeQuickAdd();
    }
  });
  (_m$querySelector = m.querySelector('[data-quick-add-backdrop]')) === null || _m$querySelector === void 0 || _m$querySelector.addEventListener('click', closeQuickAdd);
  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape' && quickAddOpen) {
      closeQuickAdd();
    }
  });
  document.addEventListener('cart:item-added', function (event) {
    var _event$detail;
    if (((_event$detail = event.detail) === null || _event$detail === void 0 ? void 0 : _event$detail.source) === 'quick-add') {
      closeQuickAdd();
    }
  });
}
bindQuickAddTriggers();
bindQuickAddModal();
})();

/******/ })()
;